export default __webpack_public_path__ + "static/IBMPlexSans-SemiBoldItalic-Greek-ce8814dced95cd191fc0f4d50d59d363.woff";